import Card from '@/view/components/Card'
import { DialogTrigger } from '@/view/components/ui/dialog'
import { ArrowRight2, Moneys } from 'iconsax-react'

interface MakeProposalCardProps {
  disabled?: boolean
  onSubmitProposal?: () => void
}
export default function MakeProposalCard({
  disabled = false,
  onSubmitProposal,
}: MakeProposalCardProps) {
  if (disabled)
    return (
      <Card variant="company-disabled">
        <div className="flex gap-2.5">
          <Moneys size={24} />
          <p className="font-normal">Realizar Proposta</p>
        </div>

        <ArrowRight2 className="text-black04" size={34} />
      </Card>
    )
  return (
    <DialogTrigger>
      <div onClick={() => onSubmitProposal?.()}>
        <Card variant="company">
          <div className="flex gap-2.5">
            <Moneys size={24} />
            <p className="font-normal">Realizar Proposta</p>
          </div>

          <ArrowRight2 className="text-white" size={34} />
        </Card>
      </div>
    </DialogTrigger>
  )
}
